import {
  CategoryBreadcrumbsLoading,
  InlineFilterLoading,
  NavigationTreeLoading,
  STREAM_TOP_SPACING,
  StreamHeaderLoading,
} from '@aboutyou/logic-components';
import {SplitView} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';
import {ProductStreamSkeleton} from './ProductStreamSkeleton';

export const CategorySkeleton: React.FC = () => {
  return (
    <div data-ssr-skeleton="CategoryPageSkeleton">
      <SplitView
        split={'30:70'}
        splitMedium={'20:80'}
        splitLarge={'15:85'}
        contentStart={<NavigationTreeLoading />}
        contentEnd={
          <ContentSection>
            <CategoryBreadcrumbsLoading />
            <StreamHeaderLoading />
            <InlineFilterLoading />
            <ProductStreamSkeleton />
          </ContentSection>
        }
      />
    </div>
  );
};

const ContentSection = styled.section`
  padding-top: ${STREAM_TOP_SPACING}px;
`;
